import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CoreDrawer,
    {
      attrs: {
        value: _vm.value,
        title: "Прочее",
        "data-qa": "analyses_other_categories_drawer",
      },
      on: {
        input: function ($event) {
          return _setup.emit("input", $event)
        },
      },
    },
    [
      _setup.isLoading
        ? _c(
            "div",
            { staticClass: "px-4" },
            _vm._l(6, function (index) {
              return _c(VSkeletonLoader, {
                key: index,
                staticClass: "mb-2",
                attrs: { type: "list-item" },
              })
            }),
            1
          )
        : _setup.isError
        ? _c("div", { staticClass: "px-4 text-body-2 text-secondary--text" }, [
            _vm._v("\n    Не удалось загрузить список\n  "),
          ])
        : _c(
            VList,
            {
              staticClass: "py-0",
              attrs: { "data-qa": "analyses_other_categories_list" },
            },
            _vm._l(_setup.items, function (item) {
              return _c(
                VListItem,
                {
                  key: item.id,
                  attrs: {
                    href: item.page_url,
                    "data-qa": "analyses_other_category_item",
                  },
                },
                [
                  _c(
                    VListItemContent,
                    [
                      _c(
                        VListItemTitle,
                        { staticClass: "text-body-1 text--text text-wrap" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(item.name_short) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    VListItemIcon,
                    { staticClass: "align-self-center my-auto" },
                    [
                      _c(VIcon, { attrs: { color: "icon-secondary" } }, [
                        _vm._v("\n          ui-icon-arrow-right\n        "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }